import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Internal linking component specifically for Finanzcoaching page
 * Optimizes SEO through strategic internal links
 */
const FinanzcoachingInternalLinks: React.FC = () => {
  const links = [
    {
      text: "Coaching-Angebote im Überblick",
      href: "/coaching", 
      description: "Alle unsere Coaching-Services"
    },
    {
      text: "Preise & Pakete", 
      href: "/preise",
      description: "Transparente Preisgestaltung"
    },
    {
      text: "Outdoor-Coaching am Rothsee",
      href: "/outdoor-coaching", 
      description: "Walk & Talk in der Natur"
    },
    {
      text: "Blog: Finanzpsychologie",
      href: "/blog",
      description: "Wissenswertes rund um Geld & Psychologie"
    }
  ];

  return (
    <section className="bg-white py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-joerg-800 mb-8 text-center">
          Weitere interessante Themen für Sie
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-4xl mx-auto">
          {links.map((link, index) => (
            <Link 
              key={index}
              to={link.href}
              className="group flex flex-col items-center justify-center text-center p-4 sm:p-5 rounded-xl border border-joerg-100 hover:border-primary/30 hover:shadow-sm transition-all min-h-[120px]"
              title={link.description}
            >
              <h3 className="font-semibold text-sm sm:text-base text-joerg-800 group-hover:text-primary transition-colors mb-1 sm:mb-2 break-words hyphens-auto" lang="de">
                {link.text}
              </h3>
              <p className="text-xs sm:text-sm text-joerg-600 leading-snug">
                {link.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinanzcoachingInternalLinks;